import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppQueries, CheckSummaryInsurance, Dispatcher } from 'src/app/state';
import { Constant } from '../../constant';
import { AccountService } from '../../service/account.service';
import { Subscription } from 'rxjs';
import { EventManagerService } from '../../service/event-manager.service';
import { Router } from '@angular/router';
import { DialogService } from '../../service/dialog.service';

@Component({
    selector: 'account-layout',
    templateUrl: './account-layout.component.html',
    styleUrls: [
        'account-layout.component.scss'
    ]
})
export class AccountLayoutComponent implements OnInit, OnDestroy {
    theme: any = {};
    Constant = Constant;
    subscriptions?: Subscription[] = [];
    userProfile: any;
    myInterval: any;
    isBroker: boolean = false;
    constructor(
        public dialogService: DialogService,
        private router: Router,
        private appQueries: AppQueries,
        private dispatcher: Dispatcher,
        private eventManager: EventManagerService,
        private accountService: AccountService
    ) {
        
    }
    getYear() {
        let date = new Date();
        return date.getFullYear();
    }
    ngOnInit() {
        this.subscriptions = [
            this.appQueries.userProfile$
            .subscribe((userProfile) => {
                this.userProfile = userProfile;
                this.isBroker = (userProfile.organizationType || {}).code === 'BANK';
                this.loadSummary();
            }),
            this.appQueries.theme$
            .subscribe((theme) => {
              this.theme = theme;
            }),
            this.eventManager.subscribe("notice-has-not-assigned-consultant-request", (res) => {
                this.openNotice();
            }),
            this.eventManager.subscribe('assigned-success', (res) => {
                this.loadSummary();
            }),
        ];
        this.myInterval = setInterval(() => {
            this.loadSummary();
        }, 60 * 1000)
    }
    ngOnDestroy(): void {
        this.eventManager.destroys(this.subscriptions);
        clearInterval(this.myInterval);
    }
    logout() {
        this.accountService.logout();
    }
    loadSummary() {
        this.dispatcher.fire(new CheckSummaryInsurance());
    }
    openNotice() {
        const properties = {
            message: `Tổ chức có phân công mới để hỗ trợ tư vấn bảo hiểm nhân thọ cho khách hàng. <br>
            Vui lòng xem thông tin khách hàng và <strong>phân công tư vấn viên</strong> liên hệ hỗ trợ trong thời gian sớm nhất.`,
            title: `Tổ chức được phân công mới`,
            func: (() => {
                this.router.navigate([
                    Constant.url_insurance_assignment_of_consultant_page,
                ]);
                this.eventManager.broadcast({
                    name: 'assigned-success'
                })
            }).bind(this),
            static: false,
            isCancelButton: false,
            buttonLabel: "Xem thông tin khách hàng & phân công TTV",
        };
        this.dialogService.showConfirm(properties);
    }
}
